<template>
  <div>
    <p>{{ $t(`message.slideTwentyExtraCommentTitle`) }}</p>
    <ul class="text-left">
      <li>{{ $t(`message.slideTwentyEmail`) }} - rwilliams@elpasompo.org</li>
      <li>
        {{ $t(`message.slideTwentyMail`) }} RMS 2050 MTP, 211 N. Florence, Suite
        202, El Paso, Texas 79901
      </li>
      <li>{{ $t(`message.slideTwentyPhone`) }} - (915) 212-0258</li>
      <li>
        {{ $t(`message.slideTwentyLastBullet`) }}
      </li>
    </ul>
    <v-row wrap>
      <v-col cols="12">
        <v-textarea
          outlined
          required
          auto-grow
          :label="$t(`message.slideTwentyCommentFieldLabel`)"
          v-model="lastCommentField"
          :disabled="commentFinish"
        />
        <v-alert type="success" v-if="commentFinish">
          <b> {{ $t(`message.SuccessSubmit`) }} </b>
        </v-alert>
        <v-alert type="error" v-if="commentError">
          <b> {{ $t(`message.ErrorSubmit`) }} </b>
        </v-alert>
        <v-btn
          depressed
          :disabled="lastCommentField === '' || commentFinish"
          @click="submitComment"
          >Submit</v-btn
        >
      </v-col>
    </v-row>
    <br /><v-divider></v-divider><br />
    <v-checkbox
      v-model="opttingIn"
      :label="$t(`message.slideTwentyOptInLabel`)"
    ></v-checkbox>
    <v-subheader class="text-left" style="font-size: large">{{
      $t(`message.slideTwentyWillNotShareText`)
    }}</v-subheader>
    <v-container grid-list-md text-center>
      <v-form ref="form">
        <v-col cols="12"> </v-col>
        <v-row wrap v-if="opttingIn">
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              required
              :label="$t(`message.slideTwentyFirstNameLabel`)"
              v-model="stakeholderLookupForm.firstName"
              :rules="rules.fnameRules"
              :error="!rules.fnameRules"
            />
          </v-col>
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              required
              :label="$t(`message.slideTwentyLastNameLabel`)"
              v-model="stakeholderLookupForm.lastName"
              :rules="rules.lnameRules"
              :error="!rules.lnameRules"
            />
          </v-col>
        </v-row>
        <v-row wrap v-if="opttingIn">
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              :label="$t(`message.slideTwentyEmailLabel`)"
              v-model="stakeholderLookupForm.email"
            />
          </v-col>
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              :label="$t(`message.slideTwentyPhoneLabel`)"
              v-model="stakeholderLookupForm.phone"
              :rules="rules.phoneRules"
              :error="!rules.phoneRules"
            />
          </v-col>
        </v-row>
        <v-row wrap v-if="opttingIn">
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              :label="$t(`message.slideTwentyAddressLabel`)"
              v-model="stakeholderLookupForm.address"
            />
          </v-col>
          <v-col :cols="cols6">
            <v-text-field
              :disabled="stakeholderFinished || exists"
              outlined
              required
              label="Zip code"
              v-model="stakeholderLookupForm.postalCode"
              :rules="rules.postalCodeRules"
              :error="!rules.postalCodeRules"
            />
          </v-col>
        </v-row>
        <v-alert type="success" v-if="stakeholderFinished">
          <b> You have successfully submitted your response! </b>
        </v-alert>
        <v-alert type="error" v-if="stakeholderError">
          <b> {{ stakeholderErrorMessage }} </b>
        </v-alert>
        <v-alert type="info" v-if="exists">
          <b> You've already submitted your information! </b>
        </v-alert>
        <v-btn v-if="opttingIn" @click="lookUpStakeholder" depressed>{{
          $t(`message.submit`)
        }}</v-btn>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rules from "@/validation.js";
import stakeholderService from "@/services/stakeholderService";

export default {
  name: "CommentForm",
  props: {
    nextSlide: { type: Function }
  },
  data() {
    return {
      stakeholderLookupForm: {
        firstName: "",
        lastName: "",
        postalCode: null,
        address: null,
        phone: null,
        email: null
      },
      opttingIn: false,
      lastCommentField: "",
      rules: rules.rules,
      postalCodeErrorText:
        "Postal code is required. Please make sure there are no errors.",
      allThreeFieldsErrorText:
        "Postal code, first and last names are required. Please make sure there are no errors.",
      insufficientFields: false,
      commentFinish: false,
      commentError: false,
      stakeholderFinished: false,
      stakeholderError: false,
      stakeholderErrorMessage:
        "Something went wrong, please try again or refresh the page",
      exists: false
    };
  },
  computed: {
    cols4() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "4";
    },
    cols8() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "8";
    },
    cols6() {
      if (this.$vuetify.breakpoint.xs) {
        return "12";
      }
      return "6";
    }
  },
  methods: {
    ...mapActions({
      addResponse: "response/addResponse"
    }),
    submitComment() {
      const payload = {
        survey: 3, // Other Comments or Questions
        survey_taker_id: 1, // anonymous user
        response_json: this.lastCommentField,
        comment_location: [],
        survey_metadata: 3 // Other Comments or Questions metadata
      };
      this.addResponse(payload)
        .then(() => {
          this.commentFinish = true;
          setTimeout(() => {
            this.commentFinish = false;
            // clear comment box to give some user feedback
            this.lastCommentField = "";
          }, 5000);
        })
        .catch(() => {
          this.commentError = true;
          setTimeout(() => {
            this.commentError = false;
          }, 5000);
        });
    },
    lookUpStakeholder() {
      if (!this.$refs.form.validate()) {
        this.showError = true;
        return;
      }

      const payload = {
        first_name: this.stakeholderLookupForm.firstName,
        last_name: this.stakeholderLookupForm.lastName,
        postal_code: this.stakeholderLookupForm.postalCode
      };

      stakeholderService
        .lookUpStakeholder(payload)
        .then(response => {
          if (response.length !== 0) {
            this.exists = true;
            setTimeout(() => {
              this.exists = false;
              this.$refs.form.reset();
            }, 5000);
            return; //stakeholder already exists
          }
          this.createStakeholder();
        })
        .catch(err => {
          this.stakeholderError = true;
          this.stakeholderErrorMessage = err;
          setTimeout(() => {
            this.stakeholderError = false;
          }, 5000);
        });
    },
    createStakeholder() {
      const payload = {
        first_name: this.stakeholderLookupForm.firstName,
        last_name: this.stakeholderLookupForm.lastName,
        postal_code: this.stakeholderLookupForm.postalCode,
        address: this.stakeholderLookupForm.address,
        phone: this.stakeholderLookupForm.phone,
        email: this.stakeholderLookupForm.email
      };
      this.sanitize(payload);
      stakeholderService
        .postStakeholder(payload)
        .then(() => {
          this.stakeholderFinished = true;
          setTimeout(() => {
            this.stakeholderFinished = false;
            this.$refs.form.reset();
            this.toggleDialog();
          }, 5000);
        })
        .catch(err => {
          this.stakeholderError = true;
          this.stakeholderErrorMessage = err;
          setTimeout(() => {
            this.stakeholderError = false;
          }, 5000);
        });
    },
    sanitize(payload) {
      for (let [field, value] of Object.entries(payload)) {
        if (!value) {
          payload[field] = null;
        }
      }
    }
    // this doesn't actually work right now - license expired
    // createGeocode() {
    //   const payload = {
    //     address: this.stakeholderLookupForm.address,
    //     postal_code: this.stakeholderLookupForm.postal_code
    //   };

    //   return stakeholderService.createGeocode(payload);
    // },
  }
};
</script>
